"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const ObjectExtensions = {
    parseJSON: function (string, parser = JSON.parse) {
        if (typeof string !== 'string')
            return string;
        try {
            const json = parser(string);
            return json;
        }
        catch (e) {
            return null;
        }
    },
    stringifyJSON: function (object, replacer, space) {
        try {
            return JSON.stringify(object, replacer, space);
        }
        catch (error) {
            return object.toString();
        }
    },
    clone: function (object, stringifier = JSON.stringify) {
        if (!object)
            return null;
        return ObjectExtensions.parseJSON(stringifier(object));
    },
    formatItem: function (item, schema) {
        return ObjectExtensions.extract(item, Object.keys(schema));
    },
    extract: function (item, keys) {
        const finalItem = {};
        for (const key of keys) {
            if (typeof item[key] !== 'undefined' && item[key] !== null)
                finalItem[key] = item[key];
        }
        return finalItem;
    },
    flatten: function (arrayOfArrays) {
        return [].concat(...arrayOfArrays);
    },
    objectValues: function (object = {}) {
        if (typeof object !== 'object')
            return [];
        const list = [];
        for (const key in object)
            list.push(object[key]);
        return list;
    },
    groupBy: function (list = [], keys = [], index = 0) {
        if (index >= keys.length)
            return list;
        const map = {};
        for (let i = 0; i < list.length; i++) {
            map[list[i][keys[index]]] = map[list[i][keys[index]]] || [];
            map[list[i][keys[index]]].push(list[i]);
        }
        for (const key in map) {
            map[key] = ObjectExtensions.groupBy(map[key], keys, index + 1);
        }
        return map;
    }
};
exports.default = ObjectExtensions;
